export default {
  loading: {
    id: 'bo_sellers-orders-drawers-financial-details-loading',
    defaultMessage: 'Fetching your cost summary...',
  },
} as const
